import { render } from "./StaffTable.vue?vue&type=template&id=066be5d0&scoped=true"
import script from "./StaffTable.vue?vue&type=script&lang=js"
export * from "./StaffTable.vue?vue&type=script&lang=js"

import "./StaffTable.vue?vue&type=style&index=0&id=066be5d0&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066be5d0"]])

export default __exports__